import React, { useState, useEffect } from 'react';
import { Routes, Route } from "react-router-dom";
import { getUserJobs } from '../../../services/jobsService';
import SmartScroll from '../../../utils/SmartScroll';
import OwnProfile from './OwnProfile';
import JobList from './sections/JobList';
import ProfileContent from './sections/ProfileContent';
import { useSelector } from "react-redux";
import { useAuth } from '../../../context/AuthContext';

const OwnProfileApp = ({ id }) => {

    const [reviews, setReviews] = useState([]);
    const [jobs, setJobs] = useState([]);
    const [subscriptions, setSubscriptions] = useState([]);
    const [projects, setProjects] = useState([]);
    const [mediaItems, setMediaItems] = useState([]);
    const [loadingMedia, setLoadingMedia] = useState(true);
    const [loading, setLoading] = useState(true); // loading state
    const [error, setError] = useState(null);

    const profileData = useSelector((state) => state.profile.data);
    const profileLoading = useSelector((state) => state.profile.loading);
    const profileError = useSelector((state) => state.profile.error);

    const { isLoggingOut, accessToken } = useAuth();

    useEffect(() => {

        if (isLoggingOut || !accessToken) return;
        const fetchAllData = async () => {
            try {
                const [
                    jobsResponse,
                ] = await Promise.all([
                    getUserJobs(),
                ]);

                setJobs(jobsResponse);
            } catch (error) {
                console.error("Error fetching data:", error);
                setError("Failed to load profile. Please try again.");
            } finally {
                setLoading(false);
            }
        };

        fetchAllData();
    }, [isLoggingOut, accessToken]);

    if (error) return <div className="error-message">{error}</div>;

    if (loading) {
        return (
            <div className='profile-spinner-container'>
                <div className='centered-content'>
                    <div className="profile-spinner-wrapper">
                        <div className="profile-spinner"></div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <>
            <SmartScroll />
            <Routes>
                {/* Parent Route for Profile Sections (Own Profile) */}
                <Route path="/" element={<OwnProfile profileData={profileData}  subscriptions={subscriptions} projects={projects} />}>
                    {/* Nested Routes for different profile sections */}
                    <Route index element={<ProfileContent jobs={jobs} setJobs={setJobs} />} />
  
                </Route>
            </Routes>
        </>
    );
};

export default OwnProfileApp;
